import tw from 'tailwind-styled-components'

export const ClockTextContainer = tw.div`
    leading-[50px]
`
export const ScriptBlue = tw.span`
    text-sky-500
`
